// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 32) return "static/js/ada630daed2a4be777f7.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"acb77e7021032bed892f","131":"5fd08a86f1c949386b6b","132":"97b3c8f99b81965522ea"}[chunkId] + ".chunk.js";
};